/*
 * Single source of truth for React Query keys.
 *
 * Every builder must stay a pure function of its arguments. The
 * @tanstack/query/exhaustive-deps lint rule descends into the arguments of the
 * call it finds in `queryKey`, so a dependency passed in is still checked
 * against the queryFn. One captured from module scope or a closure instead
 * would be invisible to the rule.
 */

const globalSearchCards = ["global", "search", "cards"] as const;

export const queryKeys = {
  apiDocumentation: () => ["api-documentation"] as const,
  employees: () => ["employees"] as const,
  eligibleSenders: () => ["cards", "eligibleSenders"] as const,

  projects: () => ["projects"] as const,
  manageProject: (projectId: string) =>
    ["projects", "manage", projectId] as const,
  departmentNames: (projectId: string) =>
    ["projects", projectId, "departmentNames"] as const,

  actions: () => ["global", "actions"] as const,

  cardErrors: () => ["cards", "errors"] as const,
  mySignedCards: () => ["cards", "my-signed-cards"] as const,

  manualDispatchCards: () => ["cards", "manual-dispatch"] as const,

  globalSearchCardsAllResults: () => globalSearchCards,
  globalSearchCards: (searchTerm: string | null) =>
    [...globalSearchCards, searchTerm] as const,

  emailUniqueness: (projectId: string, email: string) =>
    ["emailUniqueness", projectId, email] as const,

  cardsInProject: (projectId: string) => ["cards", "list", projectId] as const,
  cardEditView: (projectId: string, cardId: string | undefined) =>
    ["cards", "edit", cardId, projectId] as const,
  cardEditViews: () => ["cards", "edit"] as const,
  cardEditViewsOfCard: (cardId: string) => ["cards", "edit", cardId] as const,
  cardSignatures: (projectId: string, cardId: string | undefined) =>
    ["project", projectId, "cards", cardId, "signatures"] as const,
  cardSignaturesInProject: (projectId: string) =>
    ["project", projectId, "cards"] as const,
};
